import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const FieldsIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M28.19 15.238h-2.286v-6.095c0-1.691-1.372-3.048-3.048-3.048h-6.095v-2.286c0-2.104-1.706-3.809-3.809-3.809s-3.809 1.706-3.809 3.809v2.286h-6.095c-1.683 0-3.048 1.364-3.048 3.048v5.79h2.286c2.286 0 4.114 1.829 4.114 4.114s-1.829 4.114-4.114 4.114h-2.286v5.79c0 1.683 1.364 3.048 3.048 3.048h5.79v-2.286c0-2.286 1.829-4.114 4.114-4.114s4.114 1.828 4.114 4.114v2.286h5.79c1.683 0 3.048-1.364 3.048-3.048v-6.095h2.286c2.104 0 3.809-1.706 3.809-3.809s-1.706-3.809-3.809-3.809z"
  }));
};
export default /*#__PURE__*/memo(FieldsIcon);